import { Component, PropSync, Vue } from "vue-property-decorator";

@Component<LightBoxReset>({
  components: {}
})
export default class LightBoxReset extends Vue {
  @PropSync("show", { type: Boolean })
  syncedShow!: boolean;

  private confirmReset() {
    this.$emit("confirmReset");
  }

  private cancel() {
    this.$emit("cancel");
  }
}
